import { ObservableModelNode } from "../observable";
import type { SpecsAutoFormFieldMetadataMap } from "../autoFormMetadata";
import {
  cloneValue,
  expectObject,
  readBoolean,
  readObjectArray,
  readString,
  splitKnown,
} from "../utils";
import { SpecsFamilyProductModel } from "./SpecsFamilyProductModel";

export class SpecsFamilyVersionModel extends ObservableModelNode {
  static autoFormFields: SpecsAutoFormFieldMetadataMap = {
    name: { label: "Version name", fieldType: "text" },
    canCombineProductsToReachMinQty: {
      label: "Can combine products to reach minimum quantity",
      fieldType: "boolean",
    },
    extra: { label: "Extra JSON", fieldType: "json", minRows: 4 },
  };

  name!: string;
  canCombineProductsToReachMinQty!: boolean;
  products!: SpecsFamilyProductModel[];
  extra!: Record<string, unknown>;

  constructor() {
    super();
    this.defineObservableValue("name", "1.0");
    this.defineObservableValue("canCombineProductsToReachMinQty", false);
    this.defineObservableValue("products", []);
    this.defineObservableValue("extra", {
      versionMajor: 1,
      versionMinor: 0,
      disableSiblingSwitching: false,
      display: {
        menuIconUrl: "",
        displayMethod: "",
        displayable: true,
      },
    });
  }

  restore(snapshot: unknown) {
    const source = expectObject(snapshot, "family version");
    this.name = readString(source, "name");
    this.canCombineProductsToReachMinQty = readBoolean(
      source,
      "canCombineProductsToReachMinQty",
      false
    );
    this.products = readObjectArray(source, "products").map((product) =>
      new SpecsFamilyProductModel().restore(product)
    );
    this.extra = splitKnown(source, [
      "name",
      "canCombineProductsToReachMinQty",
      "products",
    ]);
    return this;
  }

  save() {
    return {
      ...cloneValue(this.extra),
      name: this.name,
      ...(this.canCombineProductsToReachMinQty
        ? { canCombineProductsToReachMinQty: true }
        : {}),
      products: this.products.map((product) => product.save()),
    };
  }
}
